module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pV"
    }
  }), _c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgments.htm#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/translators_acknowledgments.htm#ack1"
    }
  }, [_vm._v("Translator’s Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction.htm#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/map.htm#map"
    }
  }, [_vm._v("Map of the Western Front, August 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch1.htm#ch1"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("ONE.")]), _vm._v(" War Breaks Out")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch2.htm#ch2"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("TWO.")]), _vm._v(" Visions of War, Dreams of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch3.htm#ch3"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("THREE.")]), _vm._v(" Farewell Ceremonies")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch4.htm#ch4"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("FOUR.")]), _vm._v(" Trial by Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch5.htm#ch5"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("FIVE.")]), _vm._v(" The Shadow of Defeat")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch6.htm#ch6"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("six.")]), _vm._v(" The Enemy Within")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch7.htm#ch7"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("SEVEN.")]), _vm._v(" Fears and Rumors")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/ch8.htm#ch8"
    }
  }, [_c('span', {
    staticClass: "fsc"
  }, [_vm._v("EIGHT.")]), _vm._v(" The Sounds of War")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "href": "#/epilogue.htm#epi"
    }
  }, [_vm._v("Epilogue: Beyond August 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/timeline.htm#time"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/notes.htm#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/index.htm#index"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0